var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-progress-component"},[_c('ui-status-bar-component',{attrs:{"percentage":_vm.percent,"rounded":false,"animated":false,"page-progress":true,"schema":"light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }